// extracted by mini-css-extract-plugin
var _1 = "column-u5r1k";
var _2 = "mb-nCPt_";
var _3 = "mt-EKC74";
export { _1 as "column", _2 as "mb", _3 as "mt" }
